import { gql } from '@apollo/client';

export const UpdateFileCropMutation = gql`
    mutation UpdateFileCrop($id: ID!, $cropInfo: ImageCropInfoArg) {
        updateFileCrop(id: $id, cropInfo: $cropInfo) {
            croppedThumbnail
        }
    }
`;
